import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { textVariantMap, textColorMap } from '../../theming';
import { generateTextStyles } from '../../utils';

/*
 * This isn't always a styled `p` element. It depends on the value of the `as` prop.
 * As of right now, there isn't a way to conditionally express something like `styled.<as>` (but it does work that way under-the-hood).
 * See https://styled-components.com/docs/api#as-polymorphic-prop
 */
const StyledHDSText = styled.p.withConfig({
  displayName: "HDSText__StyledHDSText",
  componentId: "sc-1tsjjr9-0"
})(({
  theme,
  $variant,
  $color,
  $display,
  $textTransform,
  $alignment,
  $wordBreak
}) => generateTextStyles({
  // @ts-expect-error - Prevents downstream builds from failing
  fontSize: theme.UNSTABLE_HDS[textVariantMap[$variant]].fontSize,
  // @ts-expect-error - Prevents downstream builds from failing
  fontWeight: theme.UNSTABLE_HDS[textVariantMap[$variant]].fontWeight,
  // @ts-expect-error - Prevents downstream builds from failing
  fontFamily: theme.UNSTABLE_HDS[textVariantMap[$variant]].fontFamily,
  // @ts-expect-error - Prevents downstream builds from failing
  lineHeight: theme.UNSTABLE_HDS[textVariantMap[$variant]].lineHeight,
  // @ts-expect-error - Prevents downstream builds from failing
  color: theme.UNSTABLE_HDS[textColorMap[$color]],
  display: $display,
  textTransform: $textTransform,
  textAlign: $alignment,
  wordBreak: $wordBreak
}));
export const HDSText = ({
  as = 'p',
  variant = 'body',
  color = 'default',
  display,
  textTransform,
  alignment,
  wordBreak,
  'data-test-id': dataTestid,
  children
}) => {
  return /*#__PURE__*/_jsx(StyledHDSText, {
    as: as,
    $variant: variant,
    $color: color,
    $display: display,
    $textTransform: textTransform,
    $alignment: alignment,
    $wordBreak: wordBreak,
    "data-test-id": dataTestid,
    children: children
  });
};